import { render, staticRenderFns } from "./Cadastro.vue?vue&type=template&id=36db86e8&scoped=true&lang=pug"
import script from "./Cadastro.vue?vue&type=script&lang=js"
export * from "./Cadastro.vue?vue&type=script&lang=js"
import style0 from "./Cadastro.vue?vue&type=style&index=0&id=36db86e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36db86e8",
  null
  
)

export default component.exports